import { createLucideIcon } from 'lucide-react';
export const PercentageIcon = createLucideIcon('percentage', [
  [
    'path',
    {
      d: 'M15.1371 5.57143L7.42279 18.4286H9.02993L16.7442 5.57143H15.1371Z',
      key: 'jvaqy3',
    },
  ],
  [
    'path',
    {
      d: 'M18 14.6243C18 13.4418 17.018 12.8571 16.2525 12.8571C15.487 12.8571 14.5714 13.4236 14.5714 14.6243V16.3914C14.5714 17.5695 15.487 18 16.2525 18C17.018 18 18 17.7165 18 16.3914V14.6243Z',
      key: '13x80q',
    },
  ],
  [
    'path',
    {
      d: 'M22 2H2V22H22V2Z',
      key: '18bf04',
    },
  ],
  [
    'path',
    {
      d: 'M9.42857 7.76717C9.42857 6.58468 8.44655 6 7.68105 6C6.91555 6 6 6.56649 6 7.76717V9.53429C6 10.7123 6.91555 11.1429 7.68105 11.1429C8.44655 11.1429 9.42857 10.8594 9.42857 9.53429V7.76717Z',
      key: 'r9fmh8',
    },
  ],
]);
